export default "__VITE_ASSET__3lyuOGav__"